namespace AgerLMS {
    export enum LessonAccessibility {
        Paid = 0,
        Free = 1
    }
    Serenity.Decorators.registerEnumType(LessonAccessibility, 'AgerLMS.LessonAccessibility');
}
